import AgendaForm from '@/app/patient/agendas/form/form'

export default {
  AgendaForm
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/search/results/components/schedule/resources/components.js